export enum Status {
	VALIDATED = 'validated',
	RELIABLE = 'reliable',
	TO_CHECK = 'toCheck'
}
